export default {
  import: 10,
  export: 20
};
